import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ModaleErroreStore } from "../store/modale-errore.store";
import { FiltroListaDistribuzioneVO } from "../vo/gescor/filtro-lista-distribuzioneVO";
 
import {throwError as observableThrowError, Observable, throwError} from "rxjs";

import { ListaDistribuzioneAnagrafeVO } from "../vo/gescor/lista-distribuzione-anagrafeVO";
import { catchError, map } from "rxjs/operators";
import { env } from "@env/environment";
import { RicercaListeDistribuzioneResponseDTO } from "../dto/anagrafe/ricerca-liste-distribuzione-responseDTO";
import { MapperFiltroListaDistribuzione } from "../mapper/anagrafe/mapper-filtro-lista-distribuzioneDTO";
import { MapperListaDistribuzioneAnagrafe } from "../mapper/anagrafe/mapper-lista-distribuzione-anagrafe";
import { RecapitoVO } from "../vo/gescor/recapitoVO";
import { RecapitoAnagrafeDTO } from "../dto/anagrafe/recapito-anagrafeDTO";
import { MapperRecapitoAnagrafe } from "../mapper/anagrafe/mapper-recapito-anagrafe";
import { ComuneUtilityDTO } from "../dto/anagrafe/comune-utilityDTO";
import { ComuneVO } from "../vo/gescor/comuneVO";
import { CreaRecapitoVO } from "../vo/gescor/crea-recapitoVO";
import { EntitaAnagrafeVO } from "../vo/gescor/entita-anagrafeVO";
import { RecapitoDTO } from "../dto/anagrafe/recapitoDTO";
import { InserisciRecapitoRequest } from "../dto/anagrafe/inserisci-recapito-requestDTO";
import { MapperCartaceo } from "../mapper/gescor/mapper-cartaceo";
import { CreaRecapitoResponseDTO } from "../dto/anagrafe/crea-recapito-responseDTO";
import {FiltroRicercaSoggettoDTO} from "@dto/anagrafe/filtro-ricerca-soggettoDTO";
import {SoggettoRicercaVO} from "@vo/soggetto-ricercaVO";
import {TipoSoggettoAnagrafeEnum} from "@enum/tipo-soggetto-anagrafe-enum";
import {SoggettoRicercaDTO} from "@dto/anagrafe/soggetto-ricercaDTO";
import {ResultListDTO} from "@dto/result-listDTO";

@Injectable({
  providedIn: "root",
})
export class AnagrafeService {
  private urlRicercaListeDistribuzione: string =
    env.API_URL_BASE + env.URL_RICERCA_LISTE_ANAGRAFE;
    private urlRicercaRecapito: string =
    env.API_URL_BASE + env.URL_RICERCA_RECAPITO;
    private urlComuni: string = env.API_URL_BASE + env.URL_RICERCA_COMUNE;
    private urlCreaRecapito: string = env.API_URL_BASE + env.URL_CREA_RECAPITO;
    private urlRicercaSoggetto: string = env.API_URL_BASE + env.URL_RICERCA_SOGGETTO;
  constructor(
    private http: HttpClient,
    private mapperFiltroListaDistribuzione: MapperFiltroListaDistribuzione,
    private mapperListaDistribuzioneAnagrafe: MapperListaDistribuzioneAnagrafe,
    private modaleErroreStore: ModaleErroreStore,
    private mapperCartaceo: MapperCartaceo,
    private mapperRecapitoAnagrafe: MapperRecapitoAnagrafe
  ) {}

  public ricercaListeDistribuzione(
    filtroListaDistribuzioneVO: FiltroListaDistribuzioneVO
  ): Observable<ListaDistribuzioneAnagrafeVO[]> {
    console.log("service ricercaListeDistribuzione");
    return this.http
      .post<RicercaListeDistribuzioneResponseDTO>(
        this.urlRicercaListeDistribuzione,
        this.mapperFiltroListaDistribuzione.convertVoToDto(
          filtroListaDistribuzioneVO
        )
      )
      .pipe(
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        }),
        map((response: RicercaListeDistribuzioneResponseDTO) =>
          this.mapperListaDistribuzioneAnagrafe.convertListDtoToVo(
            response.resultList
          )
        )
      );
  }

  public cercaRecapito(recapito: string): Observable<RecapitoVO> {
    console.log("cercaRecapito: ", recapito);
    console.log("call: ", this.urlRicercaRecapito + recapito);
    return this.http.get<RecapitoAnagrafeDTO>(this.urlRicercaRecapito + recapito).pipe(
      catchError(err => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      }),
      map((response: RecapitoAnagrafeDTO) =>
        this.mapperRecapitoAnagrafe.convertDtoToVo(response)
      )
    );
  }

  public ricercaComune(filtro: string): Observable<ComuneVO[]> {
    return this.http.get<ComuneUtilityDTO[]>(this.urlComuni + filtro).pipe(
      catchError(err => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      }),
      map((response: ComuneUtilityDTO[]) => response.map(value => this.convertiComune(value)))
    );
  }

  private convertiComune(comuneDTO: ComuneUtilityDTO): ComuneVO {
    return {
      nome: comuneDTO.nome,
      codiceIstat: comuneDTO.codiceIstat,
      provincia: comuneDTO.provincia,
      cap: comuneDTO.cap
    };
  }

  public creaRecapito(
    idSoggetto: string,
    creaRecapito: CreaRecapitoVO
  ): Observable<EntitaAnagrafeVO> {
    console.log("service creaRecapito", creaRecapito);
    const url: string = this.urlCreaRecapito.replace("{id}", idSoggetto);
    const request: InserisciRecapitoRequest = new InserisciRecapitoRequest();
    request.cartaceo = this.mapperCartaceo.convertVoToDto(
      creaRecapito.cartaceo
    );
    return this.http.post<CreaRecapitoResponseDTO>(url, request).pipe(
      catchError(err => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      }),
      map((response: CreaRecapitoResponseDTO) => {
        const entitaAnagrafe: EntitaAnagrafeVO = new EntitaAnagrafeVO();
        const recapito: RecapitoDTO = response.recapito;
        entitaAnagrafe.idSoggetto = String(recapito.idSoggetto);
        entitaAnagrafe.idRecapito = String(recapito.id);
        return entitaAnagrafe;
      })
    );
  }

  ricercaSoggetti(
      filtroDTO: FiltroRicercaSoggettoDTO,
      tipoAnagrafica: string
  ): Observable<SoggettoRicercaVO[]> {

    if (tipoAnagrafica === "PUBBLICA_AMMINISTRAZIONE") {
      filtroDTO.filtroRicerca.tipo = TipoSoggettoAnagrafeEnum.AMMINISTRAZIONE;
    } else {
      filtroDTO.filtroRicerca.tipo = TipoSoggettoAnagrafeEnum[tipoAnagrafica];
    }
    console.log("filtro", filtroDTO);
    return this.http
        .post(this.urlRicercaSoggetto, filtroDTO)
        .pipe(
            map((response: ResultListDTO<SoggettoRicercaDTO>) => {
              return this.convertData(response);
            }),
            catchError((err) => {
              console.log("[AnagrafeService.ricercaSoggetti] err:", err);
              return throwError(err);
            })
        );
  }

  private convertData(soggetto: ResultListDTO<SoggettoRicercaDTO>) {

    let soggettiVO: SoggettoRicercaVO[];
    console.log("numero risultati: " + soggetto.resultList.length);
    soggettiVO = new Array<SoggettoRicercaVO>();
    soggetto.resultList.forEach((element) => {
      const soggettoVO = new SoggettoRicercaVO();

      soggettoVO.nome = element.nome;
      soggettoVO.cognome = element.cognome;
      soggettoVO.codiceFiscale = element.codiceFiscale;
      soggettoVO.nome = element.nome;
      soggettoVO.tipo = element.tipo;
      if (element.sistemaProvenienza === "IPA") {
        soggettoVO.ipa = true;
      }
      if (!element.denominazione) {
        soggettoVO.denominazione = element.nome + " " + element.cognome;
      } else {
        soggettoVO.denominazione = element.denominazione;
      }
      if (soggettoVO.ipa) {
        soggettoVO.denominazione = soggettoVO.denominazione;
        soggettoVO.output = soggettoVO.denominazione + " - " + soggettoVO.codiceFiscale + " (IPA)";
      } else {
        soggettoVO.output = soggettoVO.denominazione;
        if (soggettoVO.codiceFiscale) {
          soggettoVO.output = soggettoVO.output + " - " + soggettoVO.codiceFiscale;
        }
      }
      soggettiVO.push(soggettoVO);
    });

    return soggettiVO;
  }

}
